import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  done: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/30",
  issue: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-500/15 dark:text-rose-300 dark:border-rose-500/30",
  na: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-700 dark:text-slate-300 dark:border-slate-600",
  pending: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/30",
  submitted: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/30",
  approved: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-500/20 dark:text-emerald-200 dark:border-emerald-500/40",
  changes_requested: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-500/15 dark:text-rose-300 dark:border-rose-500/30",
  draft: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-700 dark:text-slate-300 dark:border-slate-600",
  sent: "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-500/15 dark:text-sky-300 dark:border-sky-500/30",
  open: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/30",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/30",
};

const DOT = {
  done: "bg-emerald-500", issue: "bg-rose-500", na: "bg-slate-400", pending: "bg-amber-500",
  submitted: "bg-emerald-500", approved: "bg-emerald-600", changes_requested: "bg-rose-500",
  draft: "bg-slate-400", open: "bg-amber-500", completed: "bg-emerald-500", sent: "bg-sky-500",
};

const LABEL = {
  done: "Complete", issue: "Issue", na: "N/A", pending: "Pending",
  submitted: "Submitted", approved: "Approved", changes_requested: "Changes Requested",
  draft: "Draft", open: "Open", completed: "Completed", sent: "Sent",
};

export function StatusPill({ status, className, testId }) {
  if (!status) return null;
  const key = String(status).toLowerCase();
  return (
    <span
      data-testid={testId || `status-pill-${key}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        MAP[key] || MAP.na,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", DOT[key] || DOT.na)} />
      {LABEL[key] || status}
    </span>
  );
}
